import {
  GetPositionSpecialistTeamDto,
  GetProjectDto,
  GetTeamDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';

export interface TeamCandidate {
  teamId: string;
  team?: GetTeamDto;
}

export const getTeamsWithMatchedPhase = <T extends TeamCandidate>(
  specialistTeams: T[] | undefined,
  pathPhaseDictionaryId?: string | null,
): T[] => {
  if (!specialistTeams || specialistTeams.length === 0) {
    return [];
  }
  const activeTeams = specialistTeams.filter(st => st.team?.active !== false);
  if (!pathPhaseDictionaryId) {
    return activeTeams;
  }
  const matchedTeams = activeTeams.filter(
    st =>
      !st.team?.pathPhaseId || st.team.pathPhaseId === pathPhaseDictionaryId,
  );
  if (matchedTeams.length === 0) {
    return activeTeams;
  }
  return matchedTeams;
};

export const getPathPhaseIdForSpecialistTeam = (
  specialistTeams: TeamCandidate[] | undefined,
  specialistTeamId: string | null | undefined,
  project?: GetProjectDto,
): string | undefined => {
  if (!specialistTeamId) {
    return undefined;
  }
  const teamPathPhaseId = specialistTeams?.find(
    st => st.teamId === specialistTeamId,
  )?.team?.pathPhaseId;
  if (
    teamPathPhaseId &&
    project?.projectPathPhases?.some(
      pp => pp.pathPhaseDictionaryId === teamPathPhaseId,
    )
  ) {
    return teamPathPhaseId;
  }
  return undefined;
};

export interface SpecialistTeamOptions {
  teams: GetTeamDto[];
  allowedTeamIds: string[];
  defaultTeamId: string | null;
}

export const getPositionSpecialistTeamOptions = (
  positionSpecialistTeams: GetPositionSpecialistTeamDto[] | undefined,
  pathPhaseDictionaryId?: string | null,
): SpecialistTeamOptions => {
  const candidates = getTeamsWithMatchedPhase(
    positionSpecialistTeams,
    pathPhaseDictionaryId,
  );
  return {
    teams: candidates.map(c => c.team).filter((t): t is GetTeamDto => !!t),
    allowedTeamIds: candidates.map(c => c.teamId),
    defaultTeamId: candidates.length === 1 ? candidates[0].teamId : null,
  };
};

export const hasPositionSpecialistTeams = (
  positionSpecialistTeams: GetPositionSpecialistTeamDto[] | undefined,
): boolean => (positionSpecialistTeams?.length ?? 0) > 0;

export const getDefaultDeliveryTeam = (
  project: GetProjectDto | undefined,
): GetTeamDto | undefined =>
  project?.projectTeams?.find(
    pt =>
      pt.main &&
      pt.active !== false &&
      pt.team?.active &&
      pt.team.company?.id === project.company?.id,
  )?.team;
